import React from 'react';
import './App.css';
import RoutesStack from './routes/RoutesStack';
import { HelmetProvider } from 'react-helmet-async';

function App() {

  return (
    <HelmetProvider>
      <div className="App">
        <RoutesStack />
      </div>
    </HelmetProvider>
  );
}

export default App;
